import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import config from './config';
import { getSecureItem } from "../../src/utils/secureStorage";
const baseQuery = fetchBaseQuery({
    baseUrl: config.API_URL,
    prepareHeaders: (headers) => {
        const token = getSecureItem('authToken');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});

const EnhancedBaseQuery = async (args, api, extraOptions) => {
    try {
        // console.log(args, api, extraOptions, "args, api, extraOptions");

        const result = await baseQuery(args, api, extraOptions);

        if (result.error) {
            // console.error("API Error:", result.error);

            // console.error("Status:", result.error.status);
            // console.error("Data:", result.error.data);
            // console.error("Error message:", result.error.message);

            if (result.error.status === 401) {
                result.error.message = 'Unauthorized';
                localStorage.clear();
                window.location.href = '/login';
            } else if (result.error.status === 403) {
                result.error.message = 'Forbidden';
            }
        } else {
            // console.log("API Success:", result.data);
        }

        return result;
    } catch (error) {
        console.error('Fetch Error:', error);

        return {
            error: {
                status: 'FETCH_ERROR',
                data: error.message || 'A network error occurred',
            },
        };
    }
};

export default EnhancedBaseQuery;
